module.exports = __webpack_public_path__ + "img/juslip3.1e339b64.svg";